import React from "react";

export type ToastAction = "saved" | "deleted";

interface ActionToastProps {
  action: ToastAction | null;
}

const ActionToast: React.FC<ActionToastProps> = ({ action }) => {
  if (!action) return null;

  const isSaved = action === "saved";

  return (
    <div className={`dashboard-action-toast ${isSaved ? "is-saved" : "is-deleted"}`} role="status" aria-live="polite">
      <i className={`fa-solid ${isSaved ? "fa-check" : "fa-xmark"}`} />
      <span>{isSaved ? "Saved successfully" : "Deleted successfully"}</span>
    </div>
  );
};

export default ActionToast;
